import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertSuccessComponent } from '../Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss'
})
export class PasswordComponent {
  isDisabled: boolean = false;
  user = [] as any;
  showNewPassword = false;
  showConfirmPassword = false;

  data = {
    SelectType: 'MobileNo',
    EmpMasterId: null,
    NewPassword: null,
    ConfirmPassword: null,
    By: null,
  };

  constructor(
    private activeModal: NgbActiveModal,
    private utility: UtilityService,
    private session: SessionService,
    private toast: ToastService,
    private modalService: NgbModal,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.data.EmpMasterId = this.user.UserId;
    this.data.By = this.user.UserId;
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.data.NewPassword == null || this.data.NewPassword == '') {
        this.toast.show({ message: "Please enter new password", type: toastTypeEnum.danger });
      } else if (this.data.ConfirmPassword == null || this.data.ConfirmPassword == '') {
        this.toast.show({ message: "Please enter confirm password", type: toastTypeEnum.danger });
      } else if (this.data.NewPassword != this.data.ConfirmPassword) {
        this.toast.show({ message: "Password and confirm password missmatch", type: toastTypeEnum.danger });
      } else {
        this.Ess_ChangePasswordUpdate();
      }
    } else {
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  Ess_ChangePasswordUpdate() {
    this.isDisabled = true;
    this.utility.Ess_ChangePasswordUpdate(this.data).subscribe({
      next: (response) => {
        if (response.ErrorCode == '01') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            this.close(true);
          });
        } else {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }

        this.isDisabled = false;
      },
      complete: () => {
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    });
  }

  togglePasswordVisibility(Flag: number) {
    if (Flag == 1) {
      this.showNewPassword = !this.showNewPassword;
    } else if (Flag == 2) {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  close(result: boolean) {
    this.activeModal.close(result);
  }
}
